<!-- Indicadores -->
<div class="row mb-3">
    <div class="col-sm-12 col-lg-4 mb-3 mb-lg-0">
        <div class="card card-border-shadow-primary card-count dep-pending h-100">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <h5 class="ms-1 mb-0 me-2 count-dep-pending">{{ counts.pending }}</h5>
                    <div class="avatar me-2">
                        <span class="avatar-initial rounded bg-label-danger">
                            <i class="ti ti-alert-triangle" style="font-size:18px"></i>
                        </span>
                    </div>
                    <h5 class="mb-0">Depósitos pendientes</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-lg-4 mb-3 mb-lg-0">
        <div class="card card-border-shadow-primary card-count dep-finalized h-100">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <h5 class="ms-1 mb-0 me-2 count-dep-finalized">{{ counts.finalized }}</h5>
                    <div class="avatar me-2">
                        <span class="avatar-initial rounded bg-label-success">
                            <i class="ti ti-circle-check" style="font-size:18px"></i>
                        </span>
                    </div>
                    <h5 class="mb-0">Depósitos finalizados</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-lg-4">
        <div class="card card-border-shadow-primary card-count dep-total h-100">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <h5 class="ms-1 mb-0 me-2 count-dep-total">{{ counts.total }}</h5>
                    <div class="avatar me-2">
                        <span class="avatar-initial rounded bg-label-primary">
                            <i class="ti ti-wallet" style="font-size:18px"></i>
                        </span>
                    </div>
                    <h5 class="mb-0">Depósitos totales</h5>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- Filtros mobile: botón encima del card -->
<div class="d-flex d-lg-none justify-content-between align-items-center mb-3">
    <span class="fw-semibold">Depósitos</span>
    <button class="btn btn-outline-secondary btn-sm dep-filter-btn" type="button" (click)="openSheet()">
        <i class="ti ti-filter me-1"></i>Filtros
        <span class="dep-filter-badge" *ngIf="hasActiveFilters()"></span>
    </button>
</div>

<!-- Card: pestañas + contenido -->
<div class="card p-4">
    <!-- Filtros desktop: fila completa encima del card de pestañas -->
<div class="row g-3 mb-3 d-none d-lg-flex">
    <div class="col-lg">
        <label class="form-label text-base">Folio</label>
        <div class="input-group input-group-merge">
            <input type="text" class="form-control" id="dep_folio" placeholder="Buscar por folio"
                [(ngModel)]="formModel.folio" (ngModelChange)="onFolioInput()" autocomplete="off">
        </div>
    </div>
    <div class="col-lg">
        <label class="form-label text-base">Depósitos realizados</label>
        <select class="form-select" [(ngModel)]="formModel.deposit_status" (change)="onSelectChange()">
            <option value="">Seleccionar</option>
            <option value="pending">Pendiente</option>
            <option value="deposited">Depositado</option>
            <option value="finalized">Finalizado</option>
        </select>
    </div>
    <div class="col-lg">
        <label class="form-label text-base">Estado del servicio</label>
        <select class="form-select" [(ngModel)]="formModel.service_status" (change)="onSelectChange()">
            <option value="">Seleccionar</option>
            <option *ngFor="let s of dataStatus" [value]="s.id">{{ s.name }}</option>
        </select>
    </div>
    <div class="col-lg">
        <label class="form-label text-base">Fecha de carga</label>
        <div class="input-group input-group-merge">
            <input type="text" class="form-control" id="dep_upload_date"
                [(ngModel)]="formModel.upload_date" autocomplete="off" placeholder="dd/mm/aaaa">
            <span class="input-group-text" (click)="removeDate('dep_upload_date')">
                <i [ngClass]="formModel.upload_date ? 'ti ti-x' : 'ti ti-calendar'"></i>
            </span>
        </div>
    </div>
    <div class="col-lg">
        <label class="form-label text-base">Fecha de descarga</label>
        <div class="input-group input-group-merge">
            <input type="text" class="form-control" id="dep_download_date"
                [(ngModel)]="formModel.download_date" autocomplete="off" placeholder="dd/mm/aaaa">
            <span class="input-group-text" (click)="removeDate('dep_download_date')">
                <i [ngClass]="formModel.download_date ? 'ti ti-x' : 'ti ti-calendar'"></i>
            </span>
        </div>
    </div>
</div>
    <!-- Pestañas -->
    <div class="viaticos-tabs">
        <button class="viaticos-tab-btn" [class.active]="activeListTab === 'unicos'" (click)="switchTab('unicos')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="7" r="4" stroke="#00A0E1" stroke-width="1.5"/>
                <path d="M12 11L12 18" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M17 19C17 20.1046 14.7614 21 12 21C9.23858 21 7 20.1046 7 19" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span>Servicios de viáticos únicos</span>
        </button>
        <button class="viaticos-tab-btn" [class.active]="activeListTab === 'compartidos'" (click)="switchTab('compartidos')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20.5 5.5C20.5 7.15685 19.1569 8.5 17.5 8.5C15.8431 8.5 14.5 7.15685 14.5 5.5C14.5 3.84315 15.8431 2.5 17.5 2.5C19.1569 2.5 20.5 3.84315 20.5 5.5Z" stroke="#141B34" stroke-width="1.5"/>
                <path d="M8.5 11.5C8.5 13.1569 7.15685 14.5 5.5 14.5C3.84315 14.5 2.5 13.1569 2.5 11.5C2.5 9.84315 3.84315 8.5 5.5 8.5C7.15685 8.5 8.5 9.84315 8.5 11.5Z" stroke="#141B34" stroke-width="1.5"/>
                <path d="M21.5 18.5C21.5 20.1569 20.1569 21.5 18.5 21.5C16.8431 21.5 15.5 20.1569 15.5 18.5C15.5 16.8431 16.8431 15.5 18.5 15.5C20.1569 15.5 21.5 16.8431 21.5 18.5Z" stroke="#141B34" stroke-width="1.5"/>
                <path d="M14.5348 4.58109C14.1554 4.52765 13.7677 4.5 13.3733 4.5C10.2974 4.5 7.62058 6.18227 6.24054 8.66317M19.7131 7.49453C20.8311 8.86497 21.5 10.6056 21.5 12.5C21.5 13.8758 21.1472 15.1705 20.5258 16.3012M15.8816 20.1117C15.0917 20.3638 14.2486 20.5 13.3733 20.5C9.58287 20.5 6.39853 17.9454 5.5 14.4898" stroke="#141B34" stroke-width="1.5"/>
            </svg>
            <span>Servicios con viáticos compartidos</span>
        </button>
    </div>

    <!-- Grid: pestaña Únicos -->
    <div class="card-body p-0 mt-3" *ngIf="activeListTab === 'unicos'">
        <ag-grid-angular
            style="width:100%;"
            class="ag-theme-alpine dep-grid"
            domLayout="autoHeight"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [loadingCellRenderer]="loadingCellRenderer"
            [loadingCellRendererParams]="loadingCellRendererParams"
            (cellClicked)="onCellClicked($event)"
            (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>

    <!-- Paginación -->
    <div class="card-footer d-flex justify-content-between align-items-center" *ngIf="activeListTab === 'unicos'">
        <div></div>
        <div class="d-flex align-items-center">
            <label class="me-2">Filas por página:</label>
            <select class="form-select form-select-sm me-2" style="width:auto"
                (change)="onPageSizeChanged($any($event.target).value)">
                <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === pageSize">{{ s }}</option>
            </select>
            <button class="btn btn-outline-secondary btn-sm me-2 btn-page" (click)="prevPage()" [disabled]="currentPage <= 1">
                <i class="ti ti-chevron-left"></i>
            </button>
            <span class="me-2">Página {{ currentPage }}</span>
            <button class="btn btn-outline-secondary btn-sm btn-page" (click)="nextPage()" [disabled]="!hasNextPage">
                <i class="ti ti-chevron-right"></i>
            </button>
        </div>
    </div>

    <!-- Pestaña Compartidos -->
    <div class="card-body p-0 mt-3" *ngIf="activeListTab === 'compartidos'">
        <div *ngIf="sharedGroupsLoading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status"></div>
        </div>
        <div *ngIf="!sharedGroupsLoading && sharedGroups.length === 0" class="text-center text-muted py-5">
            No hay servicios con viáticos compartidos.
        </div>
        <ag-grid-angular
            *ngIf="!sharedGroupsLoading && sharedGroups.length > 0"
            style="width:100%;"
            class="ag-theme-alpine dep-grid"
            domLayout="autoHeight"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [loadingCellRenderer]="loadingCellRenderer"
            [loadingCellRendererParams]="loadingCellRendererParams"
            (cellClicked)="onSharedCellClicked($event)"
            (gridReady)="onSharedGridReady($event)">
        </ag-grid-angular>
    </div>
</div>

<ngx-spinner bdColor="rgba(0,0,0,0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size:20px;color:white">Cargando información</p>
</ngx-spinner>

<!-- Action Sheet overlay -->
<div class="dep-sheet-overlay" *ngIf="sheetOpen" (click)="closeSheet()"></div>

<!-- Action Sheet: Filtros mobile -->
<div class="dep-sheet" [class.dep-sheet--open]="sheetOpen">
    <div class="dep-sheet__handle"></div>

    <div class="dep-sheet__header">
        <h6 class="dep-sheet__title">Filtros</h6>
        <button class="dep-sheet__close" type="button" (click)="closeSheet()">
            <i class="ti ti-x"></i>
        </button>
    </div>

    <div class="dep-sheet__body">
        <div class="mb-3">
            <label class="form-label">Depósitos realizados</label>
            <select class="form-select" [(ngModel)]="formModel.deposit_status">
                <option value="">Seleccionar</option>
                <option value="pending">Pendiente</option>
                <option value="deposited">Depositado</option>
                <option value="finalized">Finalizado</option>
            </select>
        </div>
        <div class="mb-3">
            <label class="form-label">Estado del servicio</label>
            <select class="form-select" [(ngModel)]="formModel.service_status">
                <option value="">Seleccionar</option>
                <option *ngFor="let s of dataStatus" [value]="s.id">{{ s.name }}</option>
            </select>
        </div>
        <div class="mb-3">
            <label class="form-label">Fecha de carga</label>
            <div class="input-group input-group-merge">
                <input type="text" class="form-control" id="dep_upload_date_sheet"
                    [(ngModel)]="formModel.upload_date" autocomplete="off" placeholder="dd/mm/aaaa">
                <span class="input-group-text" (click)="removeDate('dep_upload_date')">
                    <i [ngClass]="formModel.upload_date ? 'ti ti-x' : 'ti ti-calendar'"></i>
                </span>
            </div>
        </div>
        <div class="mb-3">
            <label class="form-label">Fecha de descarga</label>
            <div class="input-group input-group-merge">
                <input type="text" class="form-control" id="dep_download_date_sheet"
                    [(ngModel)]="formModel.download_date" autocomplete="off" placeholder="dd/mm/aaaa">
                <span class="input-group-text" (click)="removeDate('dep_download_date')">
                    <i [ngClass]="formModel.download_date ? 'ti ti-x' : 'ti ti-calendar'"></i>
                </span>
            </div>
        </div>
        <div class="mb-4">
            <label class="form-label">Folio</label>
            <div class="input-group input-group-merge">
                <input type="text" class="form-control" id="dep_folio_sheet" placeholder="Buscar por folio"
                    [(ngModel)]="formModel.folio" autocomplete="off">
            </div>
        </div>
        <div class="d-flex gap-2">
            <button class="btn btn-outline-secondary flex-fill" type="button" (click)="clearSheetFilters()">Limpiar</button>
            <button class="btn btn-primary flex-fill" type="button" (click)="applySheetFilters()">Aplicar filtros</button>
        </div>
    </div>
</div>
